import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: '{currencySymbol} Reserve overview',

  userCaption: 'Your information',
  noConnectWalletCaption: 'Please connect a wallet',
  noConnectWalletDescription:
    'We couldn’t detect a wallet. Please connect a wallet to view your personal information here.',

  provideLiquidity: 'Provide liquidity {here}',
  here: 'here',
});
